import { set } from 'lodash'
import config from '@/cms.config'
import RestfulModel from './utils/restful-model'

export class Resource extends RestfulModel {
  static entity = 'Resource'
  static endpoint = '/resources'
  static Models = { Resource }
  static typeKey = 'resource_class_name'

  static isInvalidated (res) {
    const now = Date.now()
    return (!!res.valid_at && res.valid_at > now) ||
        (!!res.invalid_at && res.invalid_at < now)
  }

  static isValidated (res) {
    return !Resource.isInvalidated(res)
  }

  static buildQuery () {
    return super.buildQuery().orderBy('sort_key').where(Resource.isValidated)
  }

  static addModel (model) {
    Resource.Models[model.entity] = model
  }

  static types () {
    return Resource.Models
  }

  static getTypeModel (name) {
    return Resource.types()[name] || Resource
  }

  get children() {
    return Resource.whereIdIn(this.children_ids).get();
  }

  get parent(){
    return this.parentResource;
  }

  static fields () {
    return {
      ...super.fields(),
      id: this.string(''),
      columns: this.attr({}),
      parent_id: this.string(''),
      // parent: this.belongsTo(this, 'parent_id'),
      children_ids: this.attr([]),
      // children: this.hasManyBy(Resource, 'children_ids'),
      resource_class_name: this.string(this.entity),
      name: this.string(''),
      path: this.string(''),
      sort_key: this.string(''),
      url: this.string('').nullable(),

      // optional
      dirty: this.boolean(false),
      highlighted: this.boolean(false),
      locked: this.boolean(false)
    }
  }

  static buildColumns(model) {
    const columns = {}
    Object.keys(model.columns).forEach((key) => {
      set(columns, key, model.columns[key])
    })
    return columns;
  }

  static beforeCreate (model) {
    model.columns = Resource.buildColumns(model)
  }

  static beforeUpdate (model) {
    model.columns = Resource.buildColumns(model)
  }

  static async $fetch (branch_id, path) {
    await super.$fetch({
      params: {
        branch_id: branch_id || 1,
        path
      }
    });
    Resource.cache = {};
  }

  get readableName () {
    return this.columns.title || this.columns.meta_title || this.name
  }

  get parentResource () {
    if (!this.parent_id) { return false }
    return Resource.find(this.parent_id)
  }

  get filteredChildren () {
    return Resource.query()
      .whereIdIn(this.children_ids)
      .where(
        (resource) =>
          !resource.url &&
          !resource.name.startsWith('_') &&
          !resource.path.split("/").find((i) => i.startsWith("_"))
      )
      .orderBy("sort_key")
      .get()
  }

  get root () {
    if (!this.parentResource) { return this }
    return this.parentResource.root
  }

  get page () {
    if (!this.columns.url && this.parentResource) {
      return this.parentResource.page
    }
    return this
  }

  getParentType (name) {
    if (this.resource_class_name === name || !this.parentResource) { return this }
    return this.parentResource.getParentType(name)
  }

  static cache = {};

  static cacheNames = config.cache?.cachedResourceColumnNames || []
  get (column) {
    if (Resource.cacheNames.includes(column)) {
      const key = `${column}-${this.columns[column]}`;
      if(!Resource.cache[key]){
        Resource.cache[key] = Resource.find(this.columns[column])
      }

      return Resource.cache[key];
    }
    return Resource.find(this.columns[column])
  }

  all (column) {
    return Resource.whereIdIn(this.columns[column]).get()
  }

  getIndex () {
    return this.parentResource ? this.parentResource.filteredChildren.findIndex(e => e.$id === this.$id) : null;
  }

  getIndexOfChildren (id) {
    return this.filteredChildren.findIndex(e => e.$id === id)
  }
}

export default Resource
